const AppConfigActionTypes = {
  SET_CURRENT_LANGUAGE: 'SET_CURRENT_LANGUAGE',
  SET_SEARCH_RESULTS_LOADED: 'SET_SEARCH_RESULTS_LOADED',
  OPEN_MOBILE_FACET: 'OPEN_MOBILE_FACET'
};

export default AppConfigActionTypes;
